import { client } from './api';

class ProductTypeService {
  getProductTypes = async () => {
    const response = await client.get('productType');
    return response;
  };
}

export default new ProductTypeService();
